import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

//Redux

import * as sessionActions from "../../redux/rides/actions";

//Components
import Reviews from "../../components/ReviewModerationMain";
import ImageModeration from "../../components/ImageModerationMain";

class Review extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  handleFetchReviewForModeration = (data) => {
    this.props.actions.fetchReviewForModeration(data);
  };

  handleFetchReviewCountry = (data) => {
    this.props.actions.fetchReviewCountry(data);
  };

  handleFetchBranch = (data) => {
    this.props.actions.fetchBranch(data);
  };

  handleFetchReviewFilter = (data) => {
    this.props.actions.fetchReviewFilter(data);
  };

  handleModerateImage = (data, reqObj, type) => {
    this.props.actions.moderateRideImages(data, reqObj, type);
  };

  handleFetchImageForModeration = (data) => {
    this.props.actions.fetchImagesForModeration(data);
  };

  handleFetchImageCountry = (data) => {
    this.props.actions.handleFetchImageCountry(data);
  };

  handleFetchImageBranch = (data) => {
    this.props.actions.handleFetchImageBranch(data);
  };

  handleFetchImageFilter = (data) => {
    this.props.actions.handleFetchImageFilter(data);
  };

  handleFetchActivityForReview = (data) => {
    this.props.actions.getActivityForReview(data);
  };

  handleFetchActivityForGallery = (data) => {
    this.props.actions.getActivityForGallery(data);
  };

  handleExportToExcel = (data) => {
    this.props.actions.exportToExcelForReview(data);
  };

  handleClearPreviousReducer = () => {
    this.props.actions.clearPreviousReducer();
  };

  render() {
    let { page } = this.props.match.params;
    switch (page) {
      case "moderation":
        return (
          <Reviews
            page={page}
            handleFetchReviewForModeration={this.handleFetchReviewForModeration}
            handleFetchReviewCountry={this.handleFetchReviewCountry}
            handleFetchBranch={this.handleFetchBranch}
            handleFetchReviewFilter={this.handleFetchReviewFilter}
            handleFetchActivityForReview={this.handleFetchActivityForReview}
            handleExportToExcel={this.handleExportToExcel}
            reviewCountriesStatus={this.props.reviewCountriesStatus}
            reviewCountries={this.props.reviewCountries}
            branchesForReviewsStatus={this.props.branchesForReviewsStatus}
            branchesForReviews={this.props.branchesForReviews}
            reviewForModeration={this.props.reviewForModeration}
            elements={this.props.elements}
            activityForReview={this.props.activityForReview}
          />
        );
      case "gallery-moderation":
        return (
          <ImageModeration
            handleModerateImage={this.handleModerateImage}
            handleFetchImageForModeration={this.handleFetchImageForModeration}
            handleFetchImageCountry={this.handleFetchImageCountry}
            handleFetchImageBranch={this.handleFetchImageBranch}
            handleFetchImageFilter={this.handleFetchImageFilter}
            handleFetchActivityForGallery={this.handleFetchActivityForGallery}
            handleClearPreviousReducer={this.handleClearPreviousReducer}
            rideImagesForModerationStatus={
              this.props.rideImagesForModerationStatus
            }
            rideImagesForModeration={this.props.rideImagesForModeration}
            rideImageCountries={this.props.rideImageCountries}
            rideImageBranches={this.props.rideImageBranches}
            moderateImage={this.props.moderateImage}
            activityForGallery={this.props.activityForGallery}
            elements={this.props.elements}
          />
        );

      default:
        return null;
    }
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(sessionActions, dispatch),
  };
}

function mapStateToProps(state) {
  return {
    reviewCountriesStatus: state.Ride.reviewCountriesStatus,
    reviewCountries: state.Ride.reviewCountries,
    branchesForReviewsStatus: state.Ride.branchesForReviewsStatus,
    branchesForReviews: state.Ride.branchesForReviews,
    reviewForModeration: state.Ride.reviewForModeration,
    elements: state.Elements.elements,
    rideImagesForModerationStatus: state.Ride.rideImagesForModerationStatus,
    rideImagesForModeration: state.Ride.rideImagesForModeration,
    rideImageCountries: state.Ride.rideImageCountries,
    rideImageBranches: state.Ride.rideImageBranches,
    moderateImage: state.Ride.moderateImage,
    activityForReview: state.Ride.activityForReview,
    activityForGallery: state.Ride.activityForGallery,
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Review));
